module.exports = __webpack_public_path__ + "images/MTS.bebfb21c2148ce47e4cba2f4dee58780.png";